import React, { PureComponent } from 'react'
import {
  Paper,
  Table,
  Grid,
  Typography,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField
} from '@material-ui/core'

import { Drivers, Buses } from 'components'

export class RouteManagmentBase extends PureComponent {
  renderGeneral = () => {
    const { classes } = this.props

    return (
      <Grid
        container
        spacing={32}
        className={classes.container}
      >

        <Grid item xs={5}>
          <Typography
            variant='h4'
            className={classes.title}
          >
            Водії
          </Typography>

          <Drivers />
        </Grid>

        <Grid item xs={7}>
          <Typography
            variant='h4'
            className={classes.title}
          >
            Автобуси
          </Typography>

          <Buses />
        </Grid>
      </Grid>
    )
  }

  onTimeChange = ({ id, routeId: cityRouteId }) => e => {
    const { updateCityTime, routeId } = this.props

    const isReturnRoute = routeId !== cityRouteId
    const value = e.target.value
    const name = e.target.name

    updateCityTime({ id, routeId, value, name, returnTime: isReturnRoute })
  }

  onTimeBlur = ({ id, routeId }) => e => {
    const { setCityTime } = this.props

    const value = e.target.value
    const name = e.target.name

    setCityTime({ id, routeId, value, name })
  }

  onStationChange = id => e => {
    const { updateCityStation } = this.props

    const value = e.target.value

    updateCityStation({ id, value })
  }

  onStationBlur = id => e => {
    const { setCityStation } = this.props

    const value = e.target.value

    setCityStation({ id, value })
  }

  renderRow = ({ id, label, station, type, arrivalTime, departureTime, routeId, returnRouteId }) => {
    const { classes } = this.props

    const isUa = type === 'ua'
    const leftColumn = isUa ? departureTime : arrivalTime
    const rightColumn = isUa ? arrivalTime : departureTime
    const leftName = isUa ? 'departureTime' : 'arrivalTime'
    const rightName = isUa ? 'arrivalTime' : 'departureTime'

    return (
      <TableRow key={id}>

        <TableCell className={classes.textCenter}>
          <TextField
            name={leftName}
            value={leftColumn}
            onBlur={this.onTimeBlur({ id, routeId })}
            onChange={this.onTimeChange({ id, routeId })}
            inputProps={{
              className: classes.timeInput
            }}
          />
        </TableCell>

        <TableCell className={classes.middleCell}>
          <TextField
            fullWidth
            label={label}
            value={station}
            onBlur={this.onStationBlur(id)}
            onChange={this.onStationChange(id)}
          />
        </TableCell>

        <TableCell className={classes.textCenter}>
          <TextField
            name={rightName}
            value={rightColumn}
            onBlur={this.onTimeBlur({ id, routeId: returnRouteId })}
            onChange={this.onTimeChange({ id, routeId: returnRouteId })}
            inputProps={{
              className: classes.timeInput
            }}
          />
        </TableCell>

      </TableRow>
    )
  }

  renderRouteInfo = () => {
    const { classes, routeCitiesInfo } = this.props
    // console.log(routeCitiesInfo)
    return (
      <Paper className={classes.container}>
        <Table>

          <TableHead>
            <TableRow>
              <TableCell className={classes.textCenter}>
                Час відправлення і прибуття з України
              </TableCell>
              <TableCell className={classes.textCenter}>
                Зупинка
              </TableCell>
              <TableCell className={classes.textCenter}>
                Час відправлення і прибуття з Польщі
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {routeCitiesInfo.map(this.renderRow)}
          </TableBody>

        </Table>
      </Paper>
    )
  }

  render() {
    return this.props.fromUaRoute
      ? this.renderRouteInfo()
      : this.renderGeneral()
  }
}



// WEBPACK FOOTER //
// ./src/components/RouteManagment/RouteManagment.js